import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonCommunicationService } from '../../../../services/common-communication.service';
import { DictionaryService } from '../../../../services/dictionary.service';
import { Store, select } from '@ngrx/store';
import { Product } from '../../../../model/product';
import { forEach } from 'lodash-es';
import { isNil, isEmpty } from 'lodash-es';
import { PartnerCustomization } from './../../../../partner-customization/partner-customization.helper';
import { ProductSCI } from '../../../../csb-core/product-sci';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import allProductsData from '../../../../../assets/json/all-products-list.json';
import { AffinityPartnerFlags } from '../../../../model/affinity-partner';

@Component({
    standalone: false,
    selector: 'app-products-tile',
    templateUrl: './products-tile.component.html',
    styleUrls: ['./products-tile.component.scss'],
})
export class ProductsTileComponent implements OnInit {
    @Input() public inputProducts = [];
    public featuredProducts = [];
    public recommendedProducts = [];
    public nonFeaturedProducts = [];
    public alternateProducts = [];
    allProducts: any;
    public unavailableProducts = [];
    public alternateProductsExist: boolean;
    private blobURL = environment.blobStorageBaseURL;
    @Output()
    public selectedProduct: EventEmitter<any> = new EventEmitter<any>();
    public ccs: CommonCommunicationService;
    public products: Product[];
    @Input() public showUmbrellaError: boolean;
    @Output()
    public emitUmbrellaError: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    anyFeaturedProduct: boolean;
    public labelsDictionary: any;
    AffinityPartnerFlags: AffinityPartnerFlags;
    isFirstconnAgent: boolean;
    constructor(
        public pccs: CommonCommunicationService,
        public dictionaryService: DictionaryService,
        private http: HttpClient,
        private _store: Store<{
            products: Product[];
            AffinityPartnerFlags: AffinityPartnerFlags;
        }>,
        private _partnerCustomization: PartnerCustomization
    ) {
        this.ccs = pccs;
        this._store.pipe(select('products')).subscribe((products) => {
            this.products = products;
        });
        this._store
            .pipe(select('AffinityPartnerFlags'))
            .subscribe((AffinityPartnerFlags) => {
                if (AffinityPartnerFlags && AffinityPartnerFlags.partnercode) {
                    if (
                        AffinityPartnerFlags.partnercode &&
                        !isNil(AffinityPartnerFlags.partnercode) &&
                        !isEmpty(AffinityPartnerFlags.partnercode)
                    ) {
                        this.AffinityPartnerFlags = AffinityPartnerFlags;
                        if (this.AffinityPartnerFlags.partnercode === 'FCONN') {
                            this.isFirstconnAgent = true;
                        }
                    }
                }
            });
    }

    ngOnInit() {
        this.allProducts = allProductsData;
        this.unavailableProducts = this.allProducts.products.filter(
            (item1) =>
                !this.inputProducts.some((item2) => item2.name === item1.name)
        );
        this.labelsDictionary = this.dictionaryService.labelDict;
        this.inputProducts.forEach((product) => {
            this.recommendedProducts.push(product);
        });
        this.checkProductsList();
        forEach(this.products, (product, index: number) => {
            product.selectedpackage = null;
            if (product.featured_ind && !this.anyFeaturedProduct) {
                this.anyFeaturedProduct = true;
            }
        });
    }

    selectProduct(productObj): void {
        if (productObj.displayProduct === true) {
            this.selectedProduct.emit(productObj);
        }
    }

    closeMessage($event) {
        this.showUmbrellaError = false;
        this.emitUmbrellaError.emit(false);
    }

    filterProducts(product) {
        return ProductSCI.filterSCIProduct(product, this.products);
    }

    checkProductsList() {
        const alternateProductNames = ['BOP', 'GL'];
        this.alternateProductsExist = alternateProductNames.every(
            (requiredProduct) =>
                this.inputProducts.some(
                    (product) => product.productId === requiredProduct
                )
        );
        if (this.alternateProductsExist) {
            this.alternateProducts = this.inputProducts.filter((product) => {
                if (product.productId === 'GL') {
                    product.alternateOption = true;
                    return true;
                }
            });

            this.recommendedProducts = this.inputProducts.filter(
                (product) => product.productId !== 'GL'
            );
        }
        const digitechProductExists = this.inputProducts.some(
            (product) => product.productId === 'CYBER-DIGITECT'
        );
        if (digitechProductExists) {
            this.unavailableProducts = this.unavailableProducts.filter(
                (product) => product.productId !== 'CYBER-ERM'
            );
        }
    }
}
